import { createFileRoute, redirect } from '@tanstack/react-router'
import { DebitNoteCreateScreen } from '@/features/accounting-bills/debit-note-create-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/bills/$billId/debit-note')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_bill_debit.create')) {
      throw redirect({ to: '/accounting/bills' })
    }
  },
  component: DebitNoteCreateRoute,
})

function DebitNoteCreateRoute() {
  const { billId } = Route.useParams()
  return <DebitNoteCreateScreen billId={billId} />
}
